import { useState } from 'react';

const useDefectsColors = () => {
  const [defectsColors, setDefectsColors] = useState<(null | string)[][]>();

  return { defectsColors, setDefectsColors };
};

export default useDefectsColors;
